/**
 * 「진화 기록」 의 알림 건수 — 기준을 바꾸는 제안 · 직접 고친 가이드가 멈춘 학습(명세 24-experience-evolution §5).
 * 매 결과마다 알리지 않는 대신 머리줄(도움말 › 진화 기록)에 건수만 보인다. 창을 열면 곧바로 0.
 * 요청이 실패하면 **더 묻지 않는다** — 로그인이 끊긴 탭이 계속 부르는 일을 만들지 않는다(다음 새로고침에 다시 시작).
 */
import { useEffect, useState } from 'react';
import { fetchNotices, EVO_SEEN_EVENT } from '../services/experience';

const POLL_MS = 10 * 60 * 1000;

export default function useEvolutionNotices(active) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!active) { setCount(0); return undefined; }
        let alive = true;
        let timer = null;
        const tick = async () => {
            try {
                const r = await fetchNotices();
                if (!alive) return;
                setCount((r && r.notices) || 0);
                timer = setTimeout(tick, POLL_MS);
            } catch (_e) { /* 실패하면 멈춘다 — 알림이 화면을 막거나 오류 로그를 채우면 안 된다 */ }
        };
        const onSeen = () => setCount(0);
        window.addEventListener(EVO_SEEN_EVENT, onSeen);
        tick();
        return () => { alive = false; if (timer) clearTimeout(timer); window.removeEventListener(EVO_SEEN_EVENT, onSeen); };
    }, [active]);
    return count;
}
